'use client';

export {
    generate as generateProductPromoInfo,
    OFFICIAL_PRODUCT_PROMO_INFO_KEY,
    showCutList as productPromoInfoShowCutList,
} from './define';

export { ProductPromoInfo } from './ProductPromoInfo';
